import ImgContainer from "components/common/img";
import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { getFormattedContactNumber, hasPermission } from "utility/helpers";
import { CellText, StyledEditIcon, StyledTrashIcon } from "assets/js/Styles";
import styled from "styled-components";

const PhotoFrame = styled.div`
  width: 50px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const governmentColumns = ({
  userImage,
  navigate,
  regions,
  provinces,
  partyList,
  selectedOption,
  handleDeleteAction,
}) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "",
      selector: ({ photo }) => photo,
      grow: 0,
      minWidth: "80px",
      sortable: false,
      style: { paddingTop: "0.5rem", paddingBottom: "0.5rem" },
      cell: ({ photo }) => (
        <PhotoFrame>
          <ImgContainer
            alt="cong-image"
            src={photo || userImage}
            width="50px"
          />
        </PhotoFrame>
      ),
    },
    {
      name: "Name",
      selector: (row) => row?.fullName,
      identifier: "fullName",
      grow: 2,
      sortable: true,
      cell: ({ fullName }) => <CellText>{fullName}</CellText>,
    },
    {
      name: "Implementing Agency",
      selector: (row) => row?.regionId,
      identifier: "regionId",
      grow: 2,
      sortable: true,
      cell: ({ regionId }) => (
        <CellText>
          {regions.find((region) => region.id === regionId)?.name}
        </CellText>
      ),
    },
    {
      name: "Province",
      selector: (row) => row?.provinceId,
      identifier: "provinceId",
      grow: 2,
      sortable: true,
      cell: ({ provinceId }) => (
        <CellText>
          {provinces.find((province) => province.id === provinceId)?.name}
        </CellText>
      ),
    },
    {
      name: "Party",
      selector: ({ partyId }) => partyId,
      identifier: "partyId",
      grow: 2,
      sortable: true,
      cell: ({ partyId }) => (
        <CellText>
          {partyList.find((party) => party.id === partyId)?.acronym}
        </CellText>
      ),
    },
    {
      name: "Contact Info",
      selector: ({ contact }) => contact,
      identifier: "contact",
      grow: 2,
      sortable: true,
      cell: ({ contact }) => (
        <CellText>{getFormattedContactNumber(contact)}</CellText>
      ),
    },
    {
      name: "COS",
      selector: ({ cosName }) => cosName,
      identifier: "cosName",
      grow: 2,
      sortable: true,
      cell: ({ cosName, cosFirstName, cosLastName }) => (
        <CellText>
          {cosFirstName && cosLastName
            ? `${cosFirstName} ${cosLastName}`
            : cosName || ""}
        </CellText>
      ),
    },
    {
      name: "Contact Info",
      selector: ({ cosContact }) => cosContact,
      identifier: "cosContact",
      grow: 2,
      sortable: true,
      cell: ({ cosContact }) => (
        <CellText>{getFormattedContactNumber(cosContact)}</CellText>
      ),
    },
    {
      name: "Action",
      selector: (row) => row?.id,
      sortable: false,
      width: "100px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row, index) => (
        <>
          {hasPermission("official-update") && (
            <>
              <StyledEditIcon
                size={16}
                id={`edit-row--${index}`}
                onClick={() => {
                  if (selectedOption.value === 7) {
                    navigate("/gov", {
                      state: {
                        governor: row,
                      },
                    });
                  } else if (selectedOption.value === 9) {
                    navigate("/vicegov", {
                      state: {
                        vicegovernor: row,
                      },
                    });
                  }
                }}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`edit-row--${index}`}
              >
                {"Edit"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("official-delete") && (
            <>
              <StyledTrashIcon
                size={16}
                id={`delete-row--${index}`}
                onClick={() => handleDeleteAction(row)}
              />
              <UncontrolledTooltip
                placement="right"
                target={`delete-row--${index}`}
              >
                {"Delete"}
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
    },
  ];
};

export default governmentColumns;
